const SEARCH_TYPES = {
  MANUAL: 'manual',
  AI: 'ai',
} as const

type SearchType = (typeof SEARCH_TYPES)[keyof typeof SEARCH_TYPES]

export { type SearchType, SEARCH_TYPES }
